module.exports = __webpack_public_path__ + "static/media/pivot.9dcfe59d.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/Corona/pivot.png
// module id = 438
// module chunks = 0